import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _get from "lodash/get";
import _flatten from "lodash/flatten";
import _compact from "lodash/compact";
export var DEFAULT_TIMEOUT = 1000;
export var adobeTargetOffer =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(mbox, timeout) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new _Promise(function (resolve, reject) {
              if (_get(window, 'adobe.target.getOffer')) {
                window.adobe.target.getOffer({
                  error: function error(status, _error) {
                    if (_get(document, 'body') && (status === 'timeout' || _error.indexOf('timed out') > -1)) {
                      var event = new CustomEvent('analyticsEvent', {
                        detail: {
                          eventType: 'error',
                          type: 'form',
                          data: {
                            errorMessage: 'Adobe Target getOffer timeout',
                            errorCode: mbox
                          }
                        }
                      });
                      document.body.dispatchEvent(event);
                    }

                    return reject(status);
                  },
                  mbox: mbox,
                  success: function success(offers) {
                    var offersList = offers || [];
                    var nestedContent = offersList.map(function (offer) {
                      return _get(offer, 'content');
                    });

                    var content = _compact(_flatten(nestedContent));

                    return resolve(content);
                  },
                  timeout: timeout || DEFAULT_TIMEOUT
                });
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function adobeTargetOffer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();